import {
  GET_SERVICE_LIST_SUCCESS,
  GET_SERVICE_LIST_FAIL,
  POST_ADD_SERVICE_SUCCESS,
  POST_ADD_SERVICE_FAIL,
  GET_AVAILABLE_SERVICES_SUCCESS,
  GET_AVAILABLE_SERVICES_FAIL,
  POST_UPDATE_SERVICES_SUCCESS,
  POST_UPDATE_SERVICES_FAIL,
  GET_SERVICE_ID_FAIL,
  GET_SERVICE_ID_SUCCESS,
  POST_DELETE_SERVICE_SUCCESS,
  POST_DELETE_SERVICE_FAIL,
  GET_ACTIVE_SERVICES_SUCCESS,
  GET_ACTIVE_SERVICES_FAIL,
  POST_TIME_ZONE_SUCCESS,
  POST_TIME_ZONE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  serviceList: [],
  error: null,
  succRes: [],
  services: [],
  serviceDetail: [],
  serviceByState: [],
  delsucc: [],
  timezoneRes: [],
};

const Demo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case POST_TIME_ZONE_SUCCESS:
      return {
        ...state,
        timezoneRes: action.payload,
      };
    case POST_TIME_ZONE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ACTIVE_SERVICES_SUCCESS:
      return {
        ...state,
        serviceByState: action.payload,
      };
    case GET_ACTIVE_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        delsucc: action.payload,
      };
    case POST_DELETE_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SERVICE_ID_SUCCESS:
      return {
        ...state,
        serviceDetail: action.payload,
      };
    case GET_SERVICE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_UPDATE_SERVICES_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case POST_UPDATE_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SERVICE_LIST_SUCCESS:
      return {
        ...state,
        serviceList: action.payload,
      };

    case GET_SERVICE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case POST_ADD_SERVICE_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case POST_ADD_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_AVAILABLE_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
      };
    case GET_AVAILABLE_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Demo;
